// extracted by mini-css-extract-plugin
module.exports = {"primeshow":"KfMMW","storyblockernewWrapper":"L0k0c","row":"r1hkk","leftColumn":"NgxDj","rightColumn":"zhW7C"};